import { FC } from 'react';
import { ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import { useSearchFilterNotesStore } from '@/stores/searchFilterNotesStore';
import type { ViewMode } from '@/types/viewMode';

const ViewToggle: FC = () => {
  const { viewMode, setViewMode } = useSearchFilterNotesStore();

  const handleChange = (_event: React.MouseEvent<HTMLElement>, newMode: ViewMode | null) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={viewMode}
      exclusive
      onChange={handleChange}
      size="small"
      aria-label="View mode"
      sx={{
        height: 36,
        '& .MuiToggleButton-root': {
          px: 1,
          border: '1px solid',
          borderColor: 'divider',
          '&.Mui-selected': {
            backgroundColor: 'action.selected',
            '&:hover': {
              backgroundColor: 'action.selected',
            },
          },
        },
      }}
    >
      <ToggleButton value="list" aria-label="List view">
        <Tooltip title="List view">
          <ViewListIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="card" aria-label="Card view">
        <Tooltip title="Card grid">
          <ViewModuleIcon fontSize="small" />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ViewToggle;
